import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    eventoId: 0,
    evento: null,
    eventoNombre: null,
    eventoEtapaId: 0,
    eventoEtapa: null,
    eventoEtapaNombre: null,
    fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    
    eventosEtapas: [],
    eventosEtapasList: [],

    exportTransferenciasDatos: [],
    exportTransferenciasRenglonesDatos: [],

    exportTransferenciasRpt: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_EXPORT' (state, exportId) {
        state.id = exportId;
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.eventoId = 0;
        state.evento = null;
        state.eventoNombre = null;
        state.eventoEtapaId = 0;
        state.eventoEtapa = null;
        state.eventoEtapaNombre = null;
        state.fechaDesde = moment(new Date()).format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
    },
    'SET_CLIENTE'(state, cliente) {
        let clienteId = 0;
        if (cliente) {
            clienteId = cliente.id || 0;
        }
        if (clienteId != state.clienteId) {
            state.cliente = cliente;
            if (cliente) {
                state.clienteId = cliente.id? cliente.id : 0;
                state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
            } else {
                state.clienteId = 0;
                state.clienteNombre = null;
            }
    
            state.eventoId = 0;
            state.evento = null;
            state.eventoNombre = null;
            state.eventoEtapaId = 0;
            state.eventoEtapaNombre = null;
            state.eventosEtapas = [];
            state.eventosEtapasList = [];
        }
    },
    'SET_EVENTO'(state, evento) {
        state.evento = evento;
        if (evento) {
            state.eventoId = evento.id? evento.id : 0;
            state.eventoNombre = evento.nombre? evento.nombre.trim() : null;
        } else {
            state.eventoId = 0;
            state.eventoNombre = null;
        }

        state.eventoEtapaId = 0;
        state.eventoEtapaNombre = null;
        state.eventosEtapas = [];
        state.eventosEtapasList = [];
    },
    'SET_EVENTO_ETAPAS'(state, eventosEtapas) {
        state.eventosEtapas = eventosEtapas;
        state.eventosEtapasList = eventosEtapas.map(item => item.nombre.trim());
    },
    'SET_EVENTO_ETAPA'(state, eventoEtapa) {
        state.eventoEtapa = eventoEtapa;
        if (eventoEtapa) {
            state.eventoEtapaId = eventoEtapa.id? eventoEtapa.id : 0;
            state.eventoEtapaNombre = eventoEtapa.nombre? eventoEtapa.nombre.trim() : null;
        } else {
            state.eventoEtapaId = 0;
            state.eventoEtapaNombre = null;
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.exportTransferenciasDatos = [];
        state.exportTransferenciasRenglonesDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.exportTransferenciasDatos = params.exportTransferenciasDatos;
        state.exportTransferenciasRenglonesDatos = params.exportTransferenciasRenglonesDatos;
    },   

    'INICIALIZAR_RPT' (state) {
        state.exportTransferenciasRpt = [];
    },
    'SET_RPT' (state, exportTransferenciasRpt) {
        state.exportTransferenciasRpt = exportTransferenciasRpt;
    },   
};

const getters = {
    getField,

    exportTransferenciasRpt(state) {
        return state.exportTransferenciasRpt;
    },
};

const actions = {
    inicializar ( { commit }, exportId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EXPORT', exportId);
            resolve();
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            if (parseInt(state.eventoId) == 0) {
                save = false;
                errorMessage = 'Debe seleccionar el evento correspondiente.';
            }
            
            if (save) {
                let exportTransferencias= {
                    eventoId: parseInt(state.eventoId),
                    fechaDesde: moment(state.fechaDesde).format('YYYY-MM-DD'),
                    fechaHasta: moment(state.fechaHasta).format('YYYY-MM-DD'),
                    eventoEtapaId: parseInt(state.eventoEtapaId),
                };

                apiAxios.post('edi/export/transferencias', exportTransferencias)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    preview ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            if (parseInt(state.eventoId) == 0) {
                save = false;
                errorMessage = 'Debe seleccionar el evento correspondiente.';
            }
            
            if (save) {
                let exportTransferencias= {
                    eventoId: parseInt(state.eventoId),
                    fechaDesde: moment(state.fechaDesde).format('YYYY-MM-DD'),
                    fechaHasta: moment(state.fechaHasta).format('YYYY-MM-DD'),
                    eventoEtapaId: parseInt(state.eventoEtapaId),
                };

                commit('INICIALIZAR_RPT');

                apiAxios.post('edi/export/transferencias/preview', exportTransferencias)
                    .then(res => {
                        commit('SET_RPT', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setCliente: ({commit}, cliente) => {
        commit('SET_CLIENTE', cliente);
    },
    setEvento: ( { commit }, evento) => {
        return new Promise((resolve, reject) => {
            commit('SET_EVENTO', evento);

            let getEtapas = false;

            if (evento) {
                if (evento.id) {
                    if (evento.id != 0) {
                        getEtapas = true;
                    }
                }
            }
            if (getEtapas) {
                apiAxios.get(`eventos/${evento.id}/etapas`)
                    .then(res => {
                        commit('SET_EVENTO_ETAPAS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                resolve();
            }
        })

    },
    setEventoEtapa: ({commit}, eventoEtapa) => {
        commit('SET_EVENTO_ETAPA', eventoEtapa);
    },
    getDatos ( { commit }, exportId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (exportId) {
                apiAxios.get('edi/export/transferencias/' + exportId) 
                    .then(res => {
                        let exportTransferenciasDatos = [
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha Emisión', 'valor': res.data.fechaRegistro, 'formato': 'fechaHora' },
                            { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                            { 'nombre': 'evento', 'campo': 'Evento', 'valor': res.data.evento, 'formato': '' },
                            { 'nombre': 'eventoEtapa', 'campo': 'Etapa', 'valor': res.data.eventoEtapa, 'formato': '' },
                            { 'nombre': 'fechaDesde', 'campo': 'Solicitudes Emitidas Desde', 'valor': res.data.fechaDesde, 'formato': 'fecha' },
                            { 'nombre': 'fechaHasta', 'campo': 'Solicitudes Emitidas Hasta', 'valor': res.data.fechaHasta, 'formato': 'fecha' },
                            { 'nombre': 'usuario', 'campo': 'Usuario', 'valor': res.data.usuario, 'formato': '' },
                        ]

                        let params = {
                            exportTransferenciasDatos,
                            exportTransferenciasRenglonesDatos: res.data.renglones
                        }
                                      
                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    getRptExportTransferencias ( { commit }, exportId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');

            apiAxios.get(`edi/export/transferencias/${exportId}`)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getTransferenciaByExport ( { commit }, exportId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');

            apiAxios.get(`edi/export/transferencias/${exportId}/transferencias`)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}